// @flow

import { startRequest, finishRequest } from "@store/utils";
import type { SpecialContactsTypesState } from "./types";

export const onGetSpecialContactTypes = (state: SpecialContactsTypesState) => () =>
  startRequest(state);

export const onGetSpecialContactTypesSuccess = (state: SpecialContactsTypesState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  list: payload,
});

export const onGetSpecialContactTypesError = (state: SpecialContactsTypesState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: payload,
  list: {
    ...state.list,
    content: [],
  },
});

export const onSetCurrentSpecialContactType = (state: SpecialContactsTypesState) => ({
  payload,
}: Object) => ({
  ...state,
  current: payload,
});

export const onSetShowSpecialContactTypeModal = (state: SpecialContactsTypesState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showTypeModal: payload,
  },
});

export const onSetShowDeleteSpecialContactTypeModal = (state: SpecialContactsTypesState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showDeleteModal: payload,
  },
});
